import { render, staticRenderFns } from "./bindPhone.vue?vue&type=template&id=78d4ce6f&scoped=true"
import script from "./bindPhone.vue?vue&type=script&lang=js"
export * from "./bindPhone.vue?vue&type=script&lang=js"
import style0 from "./bindPhone.vue?vue&type=style&index=0&id=78d4ce6f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d4ce6f",
  null
  
)

export default component.exports